import React from 'react'
import { observer } from 'mobx-react'
import { PromoteToOwnerViewModel } from './PromoteToOwnerViewModel'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import Button from 'components/Button'
import AnimatedIcon from 'components/AnimatedIcon'
import styles from './PromoteToOwnerDialog.m.sass'

interface Props {
  vm: PromoteToOwnerViewModel
}

const PromoteToOwnerDialog = observer(({ vm }: Props) => {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_workspace-settings.svg')}
            alt="Illustration of assigning users"
          />
          <ModalSheetContentTitle>
            <span className={styles.titleRow}>
              <AnimatedIcon name="stars" size={28} />
              Promote to Owner
              <AnimatedIcon name="stars" size={28} />
            </span>
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            You are about to promote yourself to owner role in{' '}
            <b>{vm.workspace.name}</b>
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Cancel
          </Button>
          <Button
            type="primary"
            data-test="promote-to-owner-confirm-button"
            onClick={vm.promote}
            disabled={vm.promote.pending}
            loading={vm.promote.pending}
          >
            Promote to Owner
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

export default PromoteToOwnerDialog
